<template>
  <div>
    <div class="card-body pb-0" v-if="errors.length">
        <base-alert  type="danger" class="mb-0">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
    </div>
    <h2><span v-if="this.$attrs.actionStatus=='Edit'">Edit</span><span v-if="this.$attrs.actionStatus!='Edit'">Setup</span> product for Online Store
        <div class="float-right">
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-if="this.$attrs.actionStatus=='Edit'" :loading="saveLoading" @click.prevent="updateParams">Update</a-button>
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-else-if="this.$attrs.actionStatus!='Edit'" :loading="saveLoading" @click.prevent="saveParams">Save</a-button>
            <a-button type="primary" class="btn float-right mr-0 bg-white text-dark mr-3 btn-sm" @click.prevent="$emit('closeProductFrom', null)">Cancel</a-button>
        </div>
    </h2>
    <div class="row mt-4 overflow-auto" style="height: 22rem;">
        <div class="col-md-12">
            <a-collapse v-model="activeKey" expand-icon-position="right" class="border-0 bg-white">
                <a-collapse-panel key="1" header="01. Basic Information" :style="customStyle">
                    <div class="row">
                        <div class="col-md-6" v-if="productDetails.product_type =='M'">
                            <base-input label="Default Price" input-classes="form-control form-control-sm">
                                <a-radio-group v-model="defaultPrice" class="mt-2">
                                    <a-radio @click.prevent="changeDefaultPrice('R')" value="R">Retail</a-radio>
                                    <a-radio @click.prevent="changeDefaultPrice('C')" value="C">Custom</a-radio>
                                </a-radio-group>
                            </base-input>
                        </div>
                        <div class="col-md-6" v-else>
                            <base-input label="Price">
                                <div class="input-group mb-3">
                                    <input class="form-control form-control-sm" min="1" step="0.01" type="number" :disabled="defaultPrice=='R'" v-model="onlineStoreParams.price" required>
                                    <div class="input-group-append d-flex">
                                        <base-dropdown v-model="defaultPrice">
                                            <base-button slot="title" type="secondary"
                                                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                                                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;padding-top: 6px;padding-bottom: 6px;" />
                                            <a class="dropdown-item" v-if="defaultPrice!='R'" @click.prevent="changeDefaultPrice('R')">Retail Price</a>
                                            <a class="dropdown-item"  v-if="defaultPrice!='C'" @click.prevent="changeDefaultPrice('C')">Custom Price</a>
                                        </base-dropdown>
                                    </div>
                                </div>
                            </base-input>
                        </div>
                        <div class="col-md-6">
                            <base-input label="Sequence No" v-model="onlineStoreParams.sequence_no" type="number" input-classes="form-control form-control-sm"/>
                        </div>
                    </div>
                    <base-input label="Tags">
                        <a-select mode="tags" v-model="onlineStoreParams.tag_temp" placeholder="Tags Mode"  input-classes="form-control form-control-sm" @change="onChangeTag()"> </a-select>
                    </base-input>
                    <base-input label="Collection">
                        <a-select v-model="onlineStoreParams.sales_channel_product_collection_id" v-if="this.$attrs.salesChannelStatus == 'Edit'">
                            <a-select-option value="">
                                Catalog
                            </a-select-option>
                            <a-select-option v-for="(collection,collectionIndex) in productDetails.collections" :key="collectionIndex" :value="collection.id">
                            {{collection.collection_name}}
                            </a-select-option>
                        </a-select>
                        <a-select v-model="onlineStoreParams.collection_index" v-else>
                            <a-select-option value="">
                                Catalog
                            </a-select-option>
                            <a-select-option v-for="(collection,collectionIndex) in productDetails.collections" :key="collectionIndex" :value="collectionIndex">
                            {{collection.collection_name}}
                            </a-select-option>
                        </a-select>
                    </base-input>
                    <br>
                    <div class="row" v-if="productDetails.product_type =='M'">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(subProduct,subProductIndex) in subProducts" v-bind:key="subProductIndex">
                                            <td>{{subProduct.name}}</td>
                                            <td><base-input min="1" type="number" :disabled="defaultPrice=='R'" v-model="subProducts[subProductIndex].ecom_price" input-classes="form-control form-control-sm" required style="width: 6rem;" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                </a-collapse-panel>
            </a-collapse>
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType','publicUrl']),
        },
        mounted: async function(){
            component_x = this
            var arr = this.$attrs.productIntegrationData
            this.salesChannelId = this.$attrs.salesChannelId
            this.defaultPrice = arr.default_price || "R"
            if (this.$attrs.salesChannelStatus == 'Edit'){
                this.onlineStoreParams.tag = arr.onlineStoreProductDetails.tag
                this.onlineStoreParams.tag_temp = arr.onlineStoreProductDetails.tag != null && arr.onlineStoreProductDetails.tag != undefined ? arr.onlineStoreProductDetails.tag.split(",") : []
                this.onlineStoreParams.sales_channel_product_collection_id = arr.onlineStoreProductDetails.sales_channel_product_collection_id != null && arr.onlineStoreProductDetails.sales_channel_product_collection_id != undefined ?  arr.onlineStoreProductDetails.sales_channel_product_collection_id : ""
                this.onlineStoreParams.price = arr.ecom_price
                this.onlineStoreParams.sequence_no = arr.onlineStoreProductDetails.sequence_no
                this.subProducts = arr.onlineStoreProductDetails.children
            }else{
                this.onlineStoreParams.tag = arr.tag 
                this.onlineStoreParams.tag_temp = arr.tag != null && arr.tag != undefined && arr.tag!="" ? arr.tag.split(",") : []
                this.onlineStoreParams.collection_index = arr.collection_index != undefined && arr.collection_index >-1 ? arr.collection_index : ""
                this.onlineStoreParams.price = arr.ecom_price || arr.retail_price
                this.onlineStoreParams.sequence_no = arr.sequence_no
                this.subProducts = arr.children
            }
            this.productDetails = arr
        },
        data(){
            return {
                saveLoading:false,
                errors:[],
                activeKey:['1'],
                customStyle:"margin-bottom: 24px;border: 1px solid #dee2e6!important;background-color: #fafafa;",
                fetching:false,
                productDetails:[],
                salesChannelId:null,
                defaultPrice:null,
                subProducts:[],
                onlineStoreParams:{
                    sequence_no:0,
                    tag:null,
                    tag_temp:[],
                    price:null,
                }

            }
        },
        methods: {
            validation(){
                this.errors = [];
                if (this.productDetails.product_type == 'M'){
                    //
                }else {
                    this.errors.push(ValidateField.required('Price', this.onlineStoreParams.price));
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            async saveParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    var SalesChannelProductPayload = {
                        sales_channel_product:{
                            sequence_no:this.onlineStoreParams.sequence_no,
                            tag:this.onlineStoreParams.tag,
                            default_price:this.defaultPrice,
                        },
                        price:this.onlineStoreParams.price,
                    }
                    this.productDetails.defaultPrice = this.defaultPrice
                    this.productDetails.product_type == "M" ? SalesChannelProductPayload.sub_products = this.formatSubPrice(this.subProducts) : ""
                    if (this.$attrs.actionStatus == "Edit"){
                        SalesChannelProductPayload.sales_channel_product.sales_channel_product_collection_id = this.onlineStoreParams.sales_channel_product_collection_id
                    }else{
                        SalesChannelProductPayload.collection_index = this.onlineStoreParams.collection_index
                    }
                    this.productDetails.onlineStoreProductDetails = SalesChannelProductPayload
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.putRequest(this.endPoint+ 'sales_channel_products/'+this.productDetails.sales_channel_product_id, null, SalesChannelProductPayload)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Created."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.productDetails.sequence_no = this.onlineStoreParams.sequence_no
                        this.productDetails.ecom_price = this.onlineStoreParams.price
                        this.productDetails.tag = this.onlineStoreParams.tag
                        this.productDetails.children = this.subProducts
                        this.productDetails.default_price = this.defaultPrice
                        this.productDetails.collection_index = this.onlineStoreParams.collection_index == "" ? -1 : this.onlineStoreParams.collection_index
                        this.$emit('integrationAddProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            async updateParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    var SalesChannelProductPayload = {
                        sales_channel_product:{
                            sequence_no:this.onlineStoreParams.sequence_no,
                            tag:this.onlineStoreParams.tag,
                            default_price:this.defaultPrice,
                        },
                        price:this.onlineStoreParams.price,
                    }
                    this.productDetails.defaultPrice = this.defaultPrice
                    this.productDetails.product_type == "M" ? SalesChannelProductPayload.sub_products = this.formatSubPrice(this.subProducts) : ""
                    if (this.$attrs.actionStatus == "Edit"){
                        SalesChannelProductPayload.sales_channel_product.sales_channel_product_collection_id = this.onlineStoreParams.sales_channel_product_collection_id
                    }else{
                        SalesChannelProductPayload.collection_index = this.onlineStoreParams.collection_index
                    }
                    this.productDetails.onlineStoreProductDetails = SalesChannelProductPayload
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.putRequest(this.endPoint+ 'sales_channel_products/'+this.productDetails.sales_channel_product_id, null, SalesChannelProductPayload)
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Updated."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.productDetails.sequence_no = this.onlineStoreParams.sequence_no
                        this.productDetails.ecom_price = this.onlineStoreParams.price
                        this.productDetails.tag = this.onlineStoreParams.tag
                        this.productDetails.children = this.subProducts
                        this.productDetails.default_price = this.defaultPrice
                        this.productDetails.collection_index = this.onlineStoreParams.collection_index == "" ? -1 : this.onlineStoreParams.collection_index
                        this.$emit('integrationUpdateProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            onChangeTag(){
                this.onlineStoreParams.tag = this.onlineStoreParams.tag_temp.toString()
            },
            formatSubPrice(products){
                var arr = []
                products.forEach((value, index) => {
                    if (value.retail_price!=value.ecom_price){
                        arr.push(value)
                    }
                });
                return arr
            },
            changeDefaultPrice(value){
                if (value == 'R'){
                    if (this.productDetails.product_type == 'M'){
                        this.subProducts.forEach((value, index) => {
                            this.subProducts[index].ecom_price = value.retail_price
                        });
                    }else{
                        this.onlineStoreParams.price = this.productDetails.retail_price  
                    }
                }
                this.defaultPrice = value
            },
        }
    };
</script>